import src from "IMAGE";
export default { src, width: 176, height: 146, blurWidth: 0, blurHeight: 0};
